// Full names for the seven order type codes (spec FR-010). Screens show the name; exports show
// "Name (CODE)" (built by the backend, see sof2_portal_backend/services/reports/orderTypeLabels.js).
// An unknown code is shown as the code itself.
export const ORDER_TYPE_NAMES = {
  WLN: 'Wireline',
  WLS: 'Wireless',
  FM: 'Fully Managed',
  SOW: 'Statement of Work',
  VUL: 'Vulcan',
  OCDR: 'Operator Connect / Direct Routing',
  CS: 'Cybersecurity'
};

export const orderTypeName = code => {
  if (code === null || code === undefined || code === '') return code;
  return ORDER_TYPE_NAMES[code] || code;
};

export const orderTypeLabel = code => {
  if (code === null || code === undefined || code === '') return code;
  return ORDER_TYPE_NAMES[code] ? `${ORDER_TYPE_NAMES[code]} (${code})` : code;
};

// Options for the "Order Type" filter. The value stays the code; only the label is the full name.
export const ORDER_TYPE_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  ...Object.keys(ORDER_TYPE_NAMES).map(code => ({ value: code, label: ORDER_TYPE_NAMES[code] }))
];

export default orderTypeName;
